<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="slide-x-transition">
        <DialogBox ref="resultDialog"></DialogBox>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-title>Crear Usuario</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn text dark @click="save">
                    Guardar
                </v-btn>
            </v-toolbar>
            <v-card :loading="loading">
                <v-card-subtitle>
                    <form>
                        <v-text-field
                            v-model="name"
                            label="Nombre"
                            required
                        ></v-text-field>
                    </form>
                </v-card-subtitle>
                <v-card-title>
                    Ubicacion:
                </v-card-title>
                <l-map 
                    id="profileMap"
                    ref="profileMap"
                    :zoom="zoom"
                    :center="center"
                    :minZoom="minZoom"
                    :maxZoom="maxZoom"
                    @click="saveLocation"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    >
                        <l-tile-layer :url="url"></l-tile-layer>
                        <l-marker :lat-lng="location" ref="location">
                            <l-icon
                                class-name="locationIcon"
                                :icon-size="dynamicSize"
                                :icon-anchor="dynamicAnchor"
                                icon-url="/img/depotImage.png"
                            />
                        </l-marker>
                </l-map>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
import * as L from 'leaflet'; 
import { LMap, LTileLayer, LMarker, LIcon} from 'vue2-leaflet';
import { getAddressFromCoords } from '../routingservice/RoutingService'
import { DB } from '../firebase/db';
import DialogBox from '../components/DialogBox'

export default {

    components: { 
        LMap, 
        LTileLayer,
        LMarker,
        LIcon,
        DialogBox
    },

    data: () => ({
        // Propiedades del mapa
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        zoom: 13,
        minZoom: 11,
        maxZoom: 17,
        center: [40.962267310600694, -5.6665274472274465],
        bounds: null,
        showParagraph: false,
        withPopup: L.latLng(40.962267310600694, -5.6665274472274465),
        withTooltip: L.latLng(40.956631, -5.6798597),
        showMap: true,
        marker: [0, 0],
        location: L.latLng(0, 0),
        address: null,
        iconSize: 64,
        //
        show: false,
        name: '',
        loading: false
    }),

    async created(){
        this.location = await this.getCurrentPos();
        this.centerUpdate(this.location);
    },

    mounted() {
        this.show = true
    },

    computed: {
        // Establece de forma dinámica el tamaño de los markers
        dynamicSize() {
            let zoomNormalizado = 1-(this.zoom/this.maxZoom);
            let reduction = 6;
            let scale = (1 / zoomNormalizado ) / reduction;
            
            if (scale > 1.4)
                scale = 1.10;

            return [this.iconSize*scale, this.iconSize*scale];
        },
        dynamicAnchor() {
            return [10, 10];
        }
    },

    methods: {

        async getCurrentPos() {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition( position => {
                    const currentPosition = [ position.coords.latitude, position.coords.longitude ];
                    resolve(currentPosition);
                },
                error => {
                    reject(error);
                })
            })
        },

        zoomUpdate (zoom) {
            this.zoom = zoom;
        },
        
        centerUpdate (center) {
            console.log("Center: ", center);
            this.center = center;
        },
        
        boundsUpdated (bounds) {
            this.bounds = bounds;
        },

        async saveLocation(event) {
            console.log(event)
            let newLocation = {
                lat: event.latlng.lat,
                lng: event.latlng.lng,
            }
            this.location = newLocation;

            const response = await getAddressFromCoords(newLocation);
            this.address = response.features[0].properties.label;
        },

        close() {
            this.$router.go(-1)
        },

        async save() {
            if(this.address != undefined) {
                this.loading = true
                const user = {
                    user: this.name,
                    name: this.name,
                    address: this.address,
                    location: this.location
                }
                await DB.collection('users').doc().set(user)
                this.loading = false
                this.close()
            }
            else {
                this.$refs.resultDialog.show('error', "La direccion seleccionada no es valida.", false);
            }
        },

    }

}
</script>

<style scoped>

    .locationIcon {
        padding: 3px;
        border: 1px solid #333;
        border-radius: 0 50% 50% 50%;
        box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
        text-align: center;
        margin: 0 !important;
    }

    #profileMap {
        width: 100vw;
        height: 53vh;
    }


</style>